/** Lead Hunter — Branchen und Google-Places-Suchbegriffe (je Branche: Primär- + Ausweichsuchen). */

export const DISPLAY_BRANCHES = [
  'Asiatische Küche', 'Bowl/Smoothies', 'Burger', 'Döner',
  'Indische Küche', 'Italienische Küche', 'Hotel', 'Industrie',
  'Bäckerei', 'Café', 'Pizzeria', 'Sushi', 'Steakhaus', 'Griechische Küche', 'Türkische Küche',
];

export const BRANCHEN_MAP = {
  'asiatische küche': 'Asiatische Küche',
  'bowl': 'Bowl/Smoothies',
  'burger': 'Burger',
  'döner': 'Döner',
  'indische': 'Indische Küche',
  'italienische': 'Italienische Küche',
  'hotel': 'Hotel',
  'industrie': 'Industrie',
  'bäckerei': 'Bäckerei',
  'café': 'Café',
  'pizzeria': 'Pizzeria',
  'sushi': 'Sushi',
  'steakhaus': 'Steakhaus',
  'griechische': 'Griechische Küche',
  'türkische': 'Türkische Küche',
};

// ─── Branş-bazlı arama konfigürasyonu ────────────────────────────────────────
export const BRANCH_SEARCH_CONFIG = {
  'Asiatische Küche': {
    primarySearch: { keywords: ['asiatisches restaurant', 'asian restaurant'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['chinesisches restaurant', 'chinese restaurant'], type: 'restaurant' },
      { keywords: ['thai restaurant', 'vietnamesisches restaurant'], type: 'restaurant' },
    ],
  },
  'Bowl/Smoothies': {
    primarySearch: { keywords: ['bowl smoothie', 'acai bowl'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['smoothie bar', 'juice bar'], type: 'cafe' },
      { keywords: ['healthy food', 'poke bowl'], type: 'restaurant' },
    ],
  },
  'Burger': {
    primarySearch: { keywords: ['burger restaurant', 'burger'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['burger laden', 'burgers'], type: 'meal_takeaway' },
    ],
  },
  'Döner': {
    primarySearch: { keywords: ['döner kebab', 'döner'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['kebab', 'kebab imbiss'], type: 'meal_takeaway' },
      { keywords: ['türkischer imbiss'], type: 'restaurant' },
    ],
  },
  'Indische Küche': {
    primarySearch: { keywords: ['indisches restaurant', 'indian restaurant'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['curry restaurant', 'tandoori'], type: 'restaurant' },
    ],
  },
  'Italienische Küche': {
    primarySearch: { keywords: ['italienisches restaurant', 'italian restaurant'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['ristorante', 'trattoria'], type: 'restaurant' },
      { keywords: ['pasta restaurant'], type: 'restaurant' },
    ],
  },
  'Hotel': {
    primarySearch: { keywords: ['hotel'], type: 'lodging' },
    fallbackSearches: [
      { keywords: ['pension', 'gasthof'], type: 'lodging' },
      { keywords: ['boutique hotel', 'aparthotel'], type: 'lodging' },
    ],
  },
  'Industrie': {
    primarySearch: { keywords: ['gastronomie grosshandel', 'food service'], type: null },
    fallbackSearches: [
      { keywords: ['catering unternehmen', 'catering service'], type: null },
      { keywords: ['grossküche', 'betriebsrestaurant'], type: 'restaurant' },
    ],
  },
  'Bäckerei': {
    primarySearch: { keywords: ['bäckerei', 'bakery'], type: 'bakery' },
    fallbackSearches: [
      { keywords: ['backstube', 'konditorei'], type: 'bakery' },
    ],
  },
  'Café': {
    primarySearch: { keywords: ['café', 'cafe'], type: 'cafe' },
    fallbackSearches: [
      { keywords: ['coffee shop', 'kaffeehaus'], type: 'cafe' },
    ],
  },
  'Pizzeria': {
    primarySearch: { keywords: ['pizzeria', 'pizza'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['pizza lieferservice', 'pizza delivery'], type: 'meal_delivery' },
    ],
  },
  'Sushi': {
    primarySearch: { keywords: ['sushi restaurant', 'sushi'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['sushi bar', 'japanisches restaurant'], type: 'restaurant' },
    ],
  },
  'Steakhaus': {
    primarySearch: { keywords: ['steakhouse', 'steakhaus'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['steak restaurant', 'grill restaurant'], type: 'restaurant' },
    ],
  },
  'Griechische Küche': {
    primarySearch: { keywords: ['griechisches restaurant', 'greek restaurant'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['taverna', 'gyros'], type: 'restaurant' },
    ],
  },
  'Türkische Küche': {
    primarySearch: { keywords: ['türkisches restaurant', 'turkish restaurant'], type: 'restaurant' },
    fallbackSearches: [
      { keywords: ['ocakbasi', 'lahmacun'], type: 'restaurant' },
    ],
  },
};

